/*
 * Footer.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */

const Footer = () => {
  return <footer className="p-4 bg-slate-900 text-white ">@Copyright by MYs Group</footer>;
};

export default Footer;
